import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=95b621fe&scoped=true"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=95b621fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b621fe",
  null
  
)

export default component.exports